import React from 'react'
import { useTranslation } from 'react-i18next';
import Card from '../../../../components/card/card.component';
import { useNavigate, useParams } from 'react-router-dom';
import { useKato } from '../../../../contexts/kato.context';
import { useShared } from '../../../../contexts/shared.context';
import { ICardName, InfrastructureSubType } from '../../../../types/kato.types';
import { TrendDown, TrendUp } from '../../../../assets/icons';
import classes from './styles.module.scss';
import { InfrastructureSubTypeToIcon } from '../../../../consts/other.conts';

const baseClass = 'infrastructure-card';
const translationKey = 'cards.infrastructure-card';

const headers = [
    'increase',
    'by-snp',
    'by-population',
]

const InfrastructureCard = () => {
    const { t } = useTranslation();
    const { basicStats } = useKato().katoGeneralInfo;
    const { setFullscreen } = useShared();
    const navigate = useNavigate();

    const { kato, link, tab } = useParams<{ kato: string; link: string; tab: string }>();

    const onClick = () => {
        setFullscreen({ open: true, type: ICardName.INFRASTRUCTURE });
        navigate(`/${kato}/${link}/${tab}/${ICardName.INFRASTRUCTURE}`);
    };

    if (!basicStats) return null;

    const data = basicStats.filter(item => item.type === 'INFRASTRUCTURE')

    if (!data || data.length === 0) return null;

    return (
        <Card
            title={t(`${translationKey}.title`)}
            subtitle={t(`${translationKey}.subtitle`, { year: new Date().getFullYear() - 1 })}
            onClick={onClick}
        >
            <div className={classes[baseClass]}>
                <div className={classes[`${baseClass}__table`]}>
                    <table>
                        <thead>
                            <tr>
                                <th className={classes[`${baseClass}__header`]}></th>
                                {
                                    headers.map((header) => (
                                        <th key={header} className={classes[`${baseClass}__header`]}>
                                            {t(`${translationKey}.${header}`)}
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item) => {
                                    const isIncreasePositive = item.increaseVal > 0;
                                    const increaseIcon = isIncreasePositive ? <TrendUp /> : <TrendDown />;
                                    const increaseColor = 'var(--color-' + (isIncreasePositive ? 'success' : 'failure') + ')';
                                    const icon = InfrastructureSubTypeToIcon[item.subType as InfrastructureSubType] || null;

                                    return (
                                        item && <tr key={item.subType}>
                                            <td>
                                                <div className={classes[`${baseClass}__title`]}>
                                                    <span className={classes[`${baseClass}__icon`]}>{icon}</span>
                                                    <span className={classes[`${baseClass}__subtype`]}>{t(`${translationKey}.${item.subType}`)}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <span className={classes[`${baseClass}__increase`]} style={{ color: increaseColor }}>
                                                    <span className={classes[`${baseClass}__increase__icon`]}>
                                                        {increaseIcon}
                                                    </span>
                                                    <span className={classes[`${baseClass}__increase__value`]}>
                                                        {item.increaseVal ?? 0}%
                                                    </span>
                                                </span>
                                            </td>
                                            <td>
                                                <span className={classes[`${baseClass}__value`]}>
                                                    {item.currentYearVal ? `${item.currentYearVal}%` : '-'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={classes[`${baseClass}__value`]}>
                                                    {item.additionalInfo?.currentYearVal ? `${item.additionalInfo?.currentYearVal}%` : '-'}
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table>
                </div>
            </div>
        </Card>
    )
}

export default InfrastructureCard